import { IGridOperator } from 'app/shared/model/grid-operator.model';

export interface ISubCaptar {
  id?: number;
  subCaptarCode?: string | null;
  gridOperator?: IGridOperator | null;
}

export const defaultValue: Readonly<ISubCaptar> = {};
